import { getAccessToken } from './accessToken';

export const getAuthHeaders = (portfolioId?: string): Record<string, string> => {
  const token = getAccessToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (portfolioId) {
    headers['X-Portfolio-ID'] = portfolioId;
  }

  // Check for active impersonation session and include header. The session
  // holds the support agent's impersonation of a real customer - never log
  // it to the browser console (DevTools, screen-share, extensions). Errors
  // stay; the catch's only job is to keep the header set from breaking.
  try {
    const impersonationSession = localStorage.getItem('impersonation_session');
    if (impersonationSession) {
      const session = JSON.parse(impersonationSession);
      if (session?.target_user_id) {
        headers['X-Impersonated-User-ID'] = session.target_user_id;
      }
    }
  } catch (e) {
    console.error('[AuthHeaders] Error reading impersonation session:', e);
  }

  return headers;
};